// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.kigo",
    name: "Kigo",
    homepage: "https://kigo.io",
    image_id: "ad83d869-de11-4685-2a24-d3ce93a86400",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/kigo-digital/id6449599872",
        android: "https://play.google.com/store/apps/details?id=com.augeo.kigo",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "kigo-mobile-app://",
        universal: "https://kigo-digital.app.link/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map